import { Component, Inject, Input, LOCALE_ID, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorEligibilityRuleHasDateUserField } from '../editor-eligibility-rule/editor-eligibility-rule-has-date-user-field.model';
import { formatDate } from '@angular/common';


@Component({
    selector: 'eas-editor-eligibility-rule-value-has-date-user-field',
    templateUrl: './editor-eligibility-rule-value.component.html',
    standalone: false
})
export class EditorEligibilityRuleValueHasDateUserFieldComponent implements OnInit, OnChanges, OnDestroy {
  @Input() rule: EditorEligibilityRuleHasDateUserField;
  @Input() affirmative: boolean;

  private destroyed$ = new Subject<void>();

  dateUserFieldNames: { id: string, name: string }[];

  value: string;

  constructor(@Inject(LOCALE_ID) private locale: string, private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.dateUserFieldNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        dateUserFieldNames => {
          this.dateUserFieldNames = dateUserFieldNames;
          this.value = this.getValue();
        }
      );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.rule || changes.affirmative) {
      this.value = this.getValue();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getValue(): string {
    if (this.dateUserFieldNames === undefined) {
      return $localize `Not available`;
    }

    const userField = this.rule.getUserFieldName(this.dateUserFieldNames);
    let value = this.affirmative
      ? $localize `Candidate has the user field ${userField}`
      : $localize `Candidate has NOT the user field ${userField}`;

    const formattedStart = this.rule.start === null ? null : formatDate(this.rule.start.toDate(), 'shortDate', this.locale);
    const formattedEnd = this.rule.end === null ? null : formatDate(this.rule.end.toDate(), 'shortDate', this.locale);
    if (this.rule.start !== null && this.rule.end !== null) {
      value = $localize `${value}, between ${formattedStart} and ${formattedEnd}`;
    } else if (this.rule.start !== null) {
      value = $localize `${value}, after ${formattedStart}`;
    } else if (this.rule.end !== null) {
      value = $localize `${value}, before ${formattedEnd}`;
    }

    return value;
  }
}
